import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MedarbejdereComponent } from './medarbejdere.component';
import { MedarbejdereGrupperModal } from './medarbejdere-grupper-modal/medarbejdere-grupper-modal';
import { MedarbejdereAfdelingerModal } from './medarbejdere-afdelinger-modal/medarbejdere-afdelinger-modal';
import { MedarbejdereNormtiderModal } from './medarbejdere-normtider-modal/medarbejdere-normtider-modal';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'app/shared/shared.module';
import { MedarbejderComponent } from './medarbejder/medarbejder.component';
import {MedarbejderSelectorComponent} from './medarbejder-selector/medarbejder-selector.component';
import { MedarbejdereRangePickerComponent } from './medarbejdere-range-picker/medarbejdere-range-picker.component';
import {MedarbejdereFravaerPickerComponent} from './medarbejdere-fravaer-picker/medarbejdere-fravaer-picker.component';
import {MedarbejdereHourInputComponent} from './medarbejdere-hour-input/medarbejdere-hour-input.component';


@NgModule({
    declarations: [
        MedarbejdereComponent,
        MedarbejderComponent,
        MedarbejdereGrupperModal,
        MedarbejdereAfdelingerModal,
        MedarbejdereNormtiderModal,
        MedarbejderSelectorComponent,
        MedarbejdereRangePickerComponent,
        MedarbejdereFravaerPickerComponent,
        MedarbejdereHourInputComponent,


    ],
    imports: [
        CommonModule,
        NgbDropdownModule,
        FormsModule,
        NgSelectModule,
        SharedModule,
    ]
})
export class MedarbejdereModule {
}
